<template>
	<div id="navbar">
		<!-- nav -->
		<nav class="mdc-toolbar mdc-toolbar--fixed nav" v-if="$route.fullPath !== '/company-registration'">
			<div class="mdc-toolbar__row main-nav">
				<section class="mdc-toolbar__section mdc-toolbar__section--align-end">
          <div class="nav__company">
            {{companyName}}
          </div>
					<div class="nav__profileName">
						<p>Hi {{profileName}}</p>
					</div>
					<!-- profile picture -->
					<img class="nav__profile" :src="profilePicture" v-if="profilePicture"/>
					<!-- menu icon -->
					<div id="nav__icon" v-bind:class="[showMenu ? 'open' : '']" v-on:click.prevent="showMenu = !showMenu">
						<span></span><span></span><span></span>
					</div>
				</section>

				<!-- <span class="profileName" v-show="firstName != ''" style="display: none;">Good morning, {{firstName}}</span> -->

				<section class="mdc-toolbar__section mdc-toolbar__section--align-start">
					<a href="/" class="nav__logo" v-on:click.prevent="goTo('/')"><img src="/static/img/logo.png" alt="BestAgent logo" /></a>
				</section>
			</div>

      <div class="mdc-toolbar__row tools-nav">
        <section class="mdc-toolbar__section mdc-toolbar__section--align-center">
          <div class="tools-nav__item" @click="$router.push('/')">
            <i class="icon ico-website"></i><span href="#">Dashboard</span>
          </div>
          <div class="tools-nav__item" @click="$router.push('/properties')">
            <i class="icon ico-properties"></i><span href="#">Properties</span>
          </div>
          <div class="tools-nav__item" @click="$router.push('/applicants')">
            <i class="icon ico-applicants"></i><span href="#">Applicants</span>
          </div>
        </section>
      </div>

			<!-- Admin Bar -->
			<div class="adminBar" v-if="isAdmin" @click="$router.push('/admin')">
				Admin User - {{companyName}}
			</div>
		</nav>

		<!-- menu -->
		<div class="menu-mobile" v-bind:style="{display: showMenu ? 'block' : 'none'}">
			<div class="menu-mobile__add-buttons">
				<a @click.prevent="goTo('/properties/add')"><i class="ico ico-home"></i></a>
				<a :href="applicantRegistrationUrl"><i class="ico ico-applicants"></i></a>
				<a :href="ownerRegistrationUrl">
          <i class="ico"><svg class="icon icon-user-tie"><use xlink:href="#icon-user-tie"></use></svg></i>
        </a>
        <symbol id="icon-user-tie" viewBox="0 0 32 32">
            <title>user-tie</title>
            <path d="M10 6c0-3.314 2.686-6 6-6s6 2.686 6 6c0 3.314-2.686 6-6 6s-6-2.686-6-6zM24.002 14h-1.107l-6.222 12.633 2.327-11.633-3-3-3 3 2.327 11.633-6.222-12.633h-1.107c-3.998 0-3.998 2.687-3.998 6v10h24v-10c0-3.313 0-6-3.998-6z"></path>
        </symbol>
				<!-- <a @click="goTo('/settings/website-setup')" :disabled="demoMode"><i class="ico ico-website"></i></a> -->
			</div>
			<div class="menu-mobile__item-container">
				<ul class="menu-mobile__item-list">
					<li class="menu-mobile__item"><a class="menu-mobile__link" href="#" v-on:click.prevent="goTo('/')"><span>Dashboard</span></a></li>
					<li class="menu-mobile__item"><a class="menu-mobile__link" href="#" v-on:click.prevent="goTo('/properties')"><span>Properties</span></a></li>
					<li class="menu-mobile__item"><a class="menu-mobile__link" href="#" v-on:click.prevent="goTo('/applicants')"><span>Applicants</span></a></li>
					<li class="menu-mobile__item"><a class="menu-mobile__link" href="#" v-on:click.prevent="goTo('/owners')"><span>Owners</span></a></li>
					<li class="menu-mobile__item"><a class="menu-mobile__link" href="#" v-on:click.prevent="goTo('/settings')"><span>Settings</span></a></li>
					<li class="menu-mobile__item"><a class="menu-mobile__link" href="#" v-on:click.prevent="goTo('/marketplace')"><span>Supplier Marketplace</span></a></li>
					<li class="menu-mobile__item"><a class="menu-mobile__link" href="#" v-on:click.prevent="goTo('/billing-panel')"><span>Billing</span></a></li>
					<li class="menu-mobile__logout menu-mobile__logout--desktop"><a class="menu-mobile__link" href="#" v-on:click.prevent="handleLogout"><i class="ico ico-logout"></i><span>Logout</span></a></li>
				</ul>
				<!-- <div>BestAgent agent number: +441566232022</div> -->
			</div>
		</div>

	</div>
</template>

<script>
import { logout } from '@/libs/auth0';

export default {
	name: 'Menu',
	data: function() {
		return {
			showMenu: false,
			showAdminBar: false
		}
	},
	computed: {
		profileName(){
			if(this.$store.getters.fullname) {
				return this.$store.getters.fullname.split(' ')[0];
			} else {
				return '';
			}
		},
		demoMode: function() {
 		  return this.$store.getters.demoMode;
	  	},
		profilePicture() {
			return this.$store.getters.photo;
		},
		isAdmin() {
			return this.$store.getters.admin;
		},
		companyName() {
			return this.$store.getters.companyName;
		},
		companyId() {
			if (this.$store.getters.adminCompanyId && this.$store.getters.adminCompanyId !== this.$store.getters.companyId) {
				return this.$store.getters.adminCompanyId;
			} else {
				return this.$store.getters.companyId;
			}
		},
		showBillingItems() {
			let companies = [];
			companies.push('20ef5ec0-6018-11e8-8f2b-d7211d45ca36'); // sarelis
			companies.push('257d5430-59ea-11e8-8f33-0f7bf7193c9c'); // forbes
			return companies.indexOf(this.companyId) > -1;
		},
		applicantRegistrationUrl() {
			return `${process.env.BASE_URL}/register/${this.companyId}`;
		},
		ownerRegistrationUrl() {
			return `${process.env.BASE_URL}/registerowner/${this.companyId}`;
		}
	},
	methods: {
		handleLogout() {
			logout();
		},
		isProd() {
			return process.env.NODE_ENV == 'production'
		},
		goTo(page) {
			this.$router.push(page);
			this.showMenu = false;
		}
	}
}
</script>

<style>

.icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  stroke-width: 0;
  stroke: currentColor;
  fill: currentColor;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue